export default __webpack_public_path__ + "static/media/Human4.cbbf1826.png";